import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api from "@/lib/api";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export default function DeleteAccount({ user, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const needsPassword = user?.auth_provider !== "google";

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/delete-account", { confirm, password: password || null });
      toast.success("Your account and data have been deleted.");
      onDeleted();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't delete your account.");
      setBusy(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="btn px-5 py-2.5 text-[13px] text-[#FCA5A5] border border-[#FCA5A5]/40 hover:bg-[#FCA5A5]/10 rounded-full"
        data-testid="settings-delete-account-btn">
        <Trash2 size={14} /> Delete account
      </button>
      <AlertDialog open={open} onOpenChange={(v) => { if (!busy) setOpen(v); }}>
        <AlertDialogContent data-testid="delete-account-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete your account permanently?</AlertDialogTitle>
            <AlertDialogDescription>
              This erases your studies, flashcards, quizzes, exams, packs, XP and gems. It can't be undone.
              Payment records are kept only as required by tax law.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="space-y-3">
            {needsPassword && (
              <div>
                <label htmlFor="delete-password" className="text-[12px] text-[#B0AEBC] mb-1 block">Your password (leave blank if you sign in with Google)</label>
                <input id="delete-password" type="password" className="input" value={password}
                  onChange={(e) => setPassword(e.target.value)} data-testid="delete-account-password" />
              </div>
            )}
            <div>
              <label htmlFor="delete-confirm" className="text-[12px] text-[#B0AEBC] mb-1 block">Type <strong>DELETE</strong> to confirm</label>
              <input id="delete-confirm" className="input" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                data-testid="delete-account-confirm-input" />
            </div>
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="delete-account-cancel">Cancel</AlertDialogCancel>
            <button onClick={submit} disabled={busy || confirm.trim().toUpperCase() !== "DELETE"}
              className="btn px-5 py-2 text-[13px] rounded-full bg-[#DC2626] text-white disabled:opacity-40"
              data-testid="delete-account-confirm-btn">
              {busy ? "Deleting…" : "Delete forever"}
            </button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
